import React, { useState, useEffect } from 'react';
import './Maintenance.scss';
import { useNavigate } from 'react-router-dom';
import { GetAllMaintenance } from "../../api/request/maintenance";

export default function Maintenance() {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();


    const getMaintenance = async () => {
        try {
          setIsLoading(true);
          const { data } = await GetAllMaintenance();
          if (!data?.data) {
          
            navigate('/dashboard'); 
          }
          setIsLoading(false);
        }
        catch (error) {
          setIsLoading(false);
        }
      }

    useEffect(() => {
        getMaintenance()
    }, []);

    return (
        <div className='maintenance-container pt-12 px-6 md:px-0'>
            <img src='/assets/logo/logo.png' className='object-contain h-8 mx-auto' alt='logo' />
            <p className='text-[#2F2B3D] text-center font-extrabold text-4xl mt-8'>We are making improvements.</p>
            <p className='text-[#615F66] text-center md:w-[60%] lg:w-[40%] mx-auto mt-4'>Our devs are about to press the magic button, so FXOpulence should be back online shortly. Sorry for the inconvenience.</p>
            <img className='mx-auto mt-6 lg:h-[400px]' src='/assets/images/maintenance.png' alt='img' />

            {/* <div className="flex justify-center lg:mt-6">
                <button className="bg-primary text-sm text-white font-semibold px-9 py-2 rounded-lg themeHover duration-500" onClick={() => { navigate(`/dashboard`) }}>
                   Go to Dashboard
                </button>
            </div> */}
        </div>
    )
}